import Openable from './lib/openable';

class Drawer extends Openable {
  constructor(element) {
    super(element);

    this.on('open', () => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    });

    this.on('close', () => {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '0';
    });

    this.classes = {
      active: 'drawer--active',
    };
  }
}

export default (element: string | HTMLElement): Drawer => new Drawer(element);
